import { UI, HStack, VStack } from '@genial/components';
import { Box } from 'native-base';
import React from 'react';

import {
  ColorCodedText,
  ColorCodedTextProps,
} from '../../../../../../../../../../components/ColorCodedText';
import { TableContent } from '../../../../../../../../../../components/TableContent';
import { RecommendedPortfolioAssetItem } from '../../../../../../../../../../store/customerAssetDetail/types';

import { PortfolioAssetItemProps } from '.';

interface PortfolioAssetField {
  key: keyof RecommendedPortfolioAssetItem;
  label: string;
  coloredField?: keyof RecommendedPortfolioAssetItem;
}

const fields: PortfolioAssetField[] = [
  { key: 'grossValueNormalized', label: 'Valor Bruto' },
  { key: 'appliedValueNormalized', label: 'Valor Investido' },
  { key: 'quantityNormalized', label: 'Quantidade' },
  {
    key: 'profitabilityFormatted',
    label: 'Rentabilidade',
    coloredField: 'profitabilityNormalized',
  },
];

const getColorSign = (value: number): ColorCodedTextProps['sign'] => {
  if (value > 0) {
    return 'positive';
  }

  if (value < 0) {
    return 'negative';
  }

  return 'neutral';
};

export const PortfolioAssetItemMobile: React.FC<PortfolioAssetItemProps> = ({ asset }) => {
  const renderField = ({ key, label, coloredField }: PortfolioAssetField) => {
    const value = `${asset[key]}`;

    return (
      <VStack key={label} w="45%" space="stack.quarck">
        <UI.Text color="neutral.black" variant="semibold">
          {label}
        </UI.Text>
        {coloredField ? (
          <ColorCodedText sign={getColorSign(Number(asset[coloredField]))} text={value} />
        ) : (
          <UI.Text color="neutral.dark">{value}</UI.Text>
        )}
      </VStack>
    );
  };

  return (
    <TableContent direction="column" p={0} px="inline.xxxs">
      <Box
        position="absolute"
        top={0}
        left={0}
        bottom={0}
        w="4px"
        backgroundColor="product.rendavariavel"
        borderTopLeftRadius="full"
        borderBottomLeftRadius="full"
      />

      <VStack padding="inset.sm" space="stack.xxxs" w="full">
        <VStack space="stack.quarck">
          <UI.Text variant="semibold" color="neutral.black">
            {asset.assetNameNormalized}
          </UI.Text>
          <UI.Text color="neutral.medium" fontSize="xs">
            {asset.assetCategoryNormalized}
          </UI.Text>
        </VStack>

        <Box w="full" h="1px" bgColor="neutral.lightest" />

        <HStack justifyContent="space-between">{fields.slice(0, 2).map(renderField)}</HStack>
        <HStack justifyContent="space-between">{fields.slice(2, 4).map(renderField)}</HStack>
      </VStack>
    </TableContent>
  );
};
